import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconOptAlt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"opt-alt, option alt, key"} maskId="square-filled-radius-0-stroke-1-IconOptAlt"><path fillRule="evenodd" clipRule="evenodd" d="M15.7 4H21V5H16.3L8.3 20H3V19H7.7L15.7 4ZM16 19H21V20H16V19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconOptAlt;
